import { useState } from "react"
import { useSelector } from "react-redux"

import Sidebar from "~/components/Sidebar/Sidebar"
import Heading from "~/components/Heading/Heading"
import Dropdown from "~/components/Dropdown/Dropdown"
import DashboardTable from "../../components/DashboardTable/DashboardTable"
import RollingTomato from "../../components/RollingTomato/RollingTomato"
import HeatmapWidget from "~/components/HeatmapWidget/HeatmapWidget"
import { filterUsers, usersWithStats } from "~/utils/DashboardUtils"
import PageContent from "~/components/PageContent/PageContent"
import PageWithSidebar from "~/components/PageWithSidebar/PageWithSidebar"
import { getLocations } from "~/utils/Locations"
import { getUser } from "~/store"

import "./Dashboard.scss"
import { WeekSelector } from "~/components/WeekSelector/WeekSelector"
import { formattedWeekLabel } from "~/utils/TimeFormatter"
import { useWeekStats } from "~/hooks/weekStats"
import { useUsers } from "~/hooks/users"

function Dashboard() {
  const user = useSelector(getUser)
  const [weekOffset, setWeekOffset] = useState(0)
  const [location, setLocation] = useState(user?.location ? user.location : "")
  const { data: users, isLoading: isLoadingUsers } = useUsers()
  const { data: weekStats, isLoading: isLoadingStats } =
    useWeekStats(weekOffset)

  const isLoading = isLoadingUsers || isLoadingStats

  const filteredUsers = filterUsers(users || [], location)
  const statsUsers = usersWithStats(filteredUsers, weekStats || {}, weekOffset)
  const sortedUsers = statsUsers.sort((a, b) => b.week_timers - a.week_timers)

  return (
    <PageWithSidebar>
      <PageContent>
        <div className="Dashboard">
          <div className="Dashboard__heading">
            <Heading text="Dashboard" />
            <div className="Dashboard__week-selector">
              <h3 className="Dashboard__week">
                <span className="Dashboard__week-label">Showing:</span>
                {formattedWeekLabel(weekOffset)}
              </h3>
              <WeekSelector weekOffset={weekOffset} onChange={setWeekOffset} />
            </div>
          </div>
          {user && (
            <div className="Dashboard__heatmap">
              <h2>My week</h2>
              <HeatmapWidget user={user} weekOffset={weekOffset} />
            </div>
          )}
          <div className="Dashboard__header">
            <h2>Team members</h2>
            <Dropdown
              value={location}
              options={getLocations("All")}
              valueChanged={setLocation}
            />
          </div>
          {isLoading ? (
            <div className="Dashboard__loader">
              <RollingTomato />
            </div>
          ) : (
            <div className="Dashboard__table">
              <DashboardTable weekOffset={weekOffset} users={sortedUsers} />
            </div>
          )}
        </div>
      </PageContent>
      <Sidebar style="primary" />
    </PageWithSidebar>
  )
}

export default Dashboard
